import { USER_SUFFIX } from '@common/types';
import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  countySchema,
  optionalNullableNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';
import { MAXIMUM_NUMBER_OF_USER_ROLES } from '@common/types/constants.ts';

const roleSchema = {
  role: yup
    .string()
    .oneOf([
      '',
      'super_admin',
      'organization_admin',
      'partner_admin',
      'user_admin',
      'wellness_coordinator',
      'care_navigator',
      'care_manager',
      'pharmacist',
      'data_analyst',
      'reporter',
      'provider',
      'quality_assurance',
      'organization_supervisor',
      'operations_coordinator',
      'buildings_manager',
      'partner_supervisor',
      'executive_reporter',
    ])
    .required(requiredErrorMessage),
  record_id: yup.string().required(requiredErrorMessage),
};

export const generalSchema = yup.object().shape({
  first_name: requiredNameSchema,
  last_name: requiredNameSchema,
  suffix: addOptionalNullableToSchema(
    yup.string().oneOf(Object.values(USER_SUFFIX)),
  ),
  team_id: yup.string().optional(),

  roles: yup
    .array()
    .of(yup.object().shape(roleSchema))
    .min(1, 'Must have at least 1 role')
    .max(
      MAXIMUM_NUMBER_OF_USER_ROLES,
      `Cannot have more than ${MAXIMUM_NUMBER_OF_USER_ROLES} roles`,
    ),
  supervisor_id: yup.string().optional(),
  title: optionalNullableNameSchema,
  street: optionalNullableNameSchema,
  suite: optionalNullableNameSchema,
  city: optionalNullableNameSchema,
  state: addOptionalNullableToSchema(stateSchema),
  zip_code: addOptionalNullableToSchema(zipSchema),
  county: addOptionalNullableToSchema(countySchema),
  phone_number: addOptionalNullableToSchema(phoneSchema),
  mobile_phone_number: addOptionalNullableToSchema(phoneSchema),
});
